import { render, staticRenderFns } from "./ComplaintStatusChart.vue?vue&type=template&id=8ffe753c&"
import script from "./ComplaintStatusChart.vue?vue&type=script&lang=ts&"
export * from "./ComplaintStatusChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports